<div class="column custom-form__block" :class="columnWidthClass">
    <b-field :label="field.label" :message="fieldMessage" :type="fieldType">
        <div class="is-flex is-h-100">
            <b-radio :name="field.name" :native-value="null" :modelValue="modelValue" @update:modelValue="onInput" v-if="field.required != true">Keine Auswahl</b-radio>
            <b-radio :name="field.name" :native-value="fieldValue" :modelValue="modelValue" @update:modelValue="onInput" v-for="fieldValue of field.values">{{ fieldValue }}</b-radio>
        </div>
    </b-field>
</div>
